import './App.css';

function App() {
  const n = new Date();
  const l = [
    [1, 16], [1, 30], [2, 13], [2, 27], [3, 13], [3, 27],
    [4, 10], [4, 24], [5, 8], [5, 22], [6, 5], [6, 19],
    [7, 3], [7, 17], [7, 31], [8, 14], [8, 28], [9, 11], [9, 25],
    [10, 9], [10, 30], [11, 13], [11, 27], [12, 11],
  ];
  const c = (e) => (new Date(2026, e[0]-1, e[1], 0, 0, 0) <= n
    && n < new Date(2026, e[0]-1, e[1], 14, 0, 0));
  const a = l.some(c);

  return (
    <div className="App">
      <header className="App-header">
        <p>
          {a ? `IGEN` : `NEM`}
        </p>
      </header>
    </div>
  );
}

export default App;
